import * as React from "react";
import type { SVGProps } from "react";
const SvgMapPinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="map-pin_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M270.636 185.3a341.331 341.331 0 0 1 582.695 241.364c0 132.18-86.015 260.436-180.308 359.976A1254.904 1254.904 0 0 1 512 928.976a1255.203 1255.203 0 0 1-161.023-142.293c-94.293-99.626-180.308-227.881-180.308-360.019A341.331 341.331 0 0 1 270.636 185.3zm217.684 831.526L512 981.327l23.68 35.499a42.666 42.666 0 0 1-47.36 0zm0 0L512 981.327c23.68 35.499 23.723 35.456 23.723 35.456l.085-.043.299-.213.98-.64 3.5-2.432c3.071-2.133 7.423-5.12 12.885-9.13a1341.133 1341.133 0 0 0 181.503-159.018c97.706-103.04 203.689-252.116 203.689-418.643a426.664 426.664 0 0 0-853.328 0c0 166.484 105.983 315.56 203.69 418.685a1340.92 1340.92 0 0 0 181.502 158.975 805.84 805.84 0 0 0 16.384 11.52l.981.683.3.213.127.086zm-61.653-590.162a85.333 85.333 0 1 1 170.666 0 85.333 85.333 0 0 1-170.666 0zM512 255.998a170.666 170.666 0 1 0 0 341.332 170.666 170.666 0 0 0 0-341.332z"
    />
  </svg>
);
export default SvgMapPinIcon;
